import { useSelector } from "react-redux";
import { utilsState } from "../../../sotre/redux/features/utilsSlice";
import DateInput from "../../../components/common/inputs/DateInput";
import UserModal from "../../../components/common/modals/user-modal/UserModal";
import { useRef, useState } from "react";
import { successMessage } from "../../../utils/toastify-message/ToastifyMessage";

export default function OrdersReportsFilter({ filterDataHandler }) {
  const { utils } = useSelector(utilsState);
  const userModalRef = useRef();
  const [user, setUser] = useState(null);

  const handleUser = (data) => {
    setUser(data.name);
    successMessage(`کاربر ${data?.name} انتخاب شد`);
    filterDataHandler({ page: 1, user: data?._id });
  };

  return (
    <div className="w-full flex flex-col flex-wrap my-8 gap-6 px-6">
      <UserModal ref={userModalRef} handleUser={handleUser} />

      <div className="w-full flex items-center flex-col sm:flex-row gap-6">
        <DateInput
          label={"از تاریخ"}
          onChange={(e) => filterDataHandler({ from: e })}
        />
        <DateInput
          label={"تا تاریخ"}
          onChange={(e) => filterDataHandler({ to: e })}
        />
        <div>
          <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
            برند
          </label>
          <select
            onChange={(e) => filterDataHandler({ brand: e.target.value })}
            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
          >
            <option value={""}>همه</option>
            <option value={"saboora"}>صبورا</option>
            <option value={"attarbashi"}>عطارباشی</option>
          </select>
        </div>
        <div>
          <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
            نقش
          </label>
          <select
            onChange={(e) =>
              filterDataHandler({ page: 1, role: e.target.value })
            }
            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-32 p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
          >
            <option value={""}>همه</option>;
            {utils?.ROLES_VALUES
              ? utils?.ROLES_VALUES?.map((item) => {
                  return <option value={item?.value}>{item?.name}</option>;
                })
              : null}
          </select>
        </div>
      </div>
    </div>
  );
}
